module.exports = __webpack_public_path__ + "static/ania_rubkiewicz-4ff2db48fbfe27f7973852be1b01191a.jpeg";